import React from "react";
import { Helmet } from "react-helmet-async";

const SEOHelmet = ({
  title = "HiveTeam",
  description = "",
  keywords = "",
  image = null,
  canonicalUrl = null,
  noindex = false,
  type = "website",
  url = null,
}) => {
  const fullTitle = title.includes("HiveTeam") ? title : `${title} | HiveTeam`;
  const defaultImage =
    "https://hiveteam.dev/static/media/hivebg.caecb0f3882bfa01106a.png";
  const ogImage = image || defaultImage;
  const pageUrl = url || canonicalUrl || "https://hiveteam.dev";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow"}
      />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:site_name" content="HiveTeam" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEOHelmet;
